var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NavBar',{scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('BackButton',{attrs:{"data-testid":"back-button"},on:{"click":_vm.onBackClick}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }